import { render, staticRenderFns } from "./ReservoirWaterRegime.vue?vue&type=template&id=c3d2ef94&scoped=true&"
import script from "./ReservoirWaterRegime.vue?vue&type=script&lang=js&"
export * from "./ReservoirWaterRegime.vue?vue&type=script&lang=js&"
import style0 from "./ReservoirWaterRegime.vue?vue&type=style&index=0&id=c3d2ef94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d2ef94",
  null
  
)

export default component.exports